"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReeRateTier = exports.WALLET_PROVIDER = exports.LISTING_STATUS = void 0;
var LISTING_STATUS;
(function (LISTING_STATUS) {
    LISTING_STATUS["sold"] = "Sold";
    LISTING_STATUS["active"] = "Active";
    LISTING_STATUS["inactive"] = "Inactive";
    LISTING_STATUS["pending_buyer_confirmation"] = "Pending Buyer Confirmation";
    LISTING_STATUS["pending_seller_confirmation"] = "Pending Seller Confirmation";
})(LISTING_STATUS = exports.LISTING_STATUS || (exports.LISTING_STATUS = {}));
var WALLET_PROVIDER;
(function (WALLET_PROVIDER) {
    WALLET_PROVIDER["xverse"] = "Xverse";
})(WALLET_PROVIDER = exports.WALLET_PROVIDER || (exports.WALLET_PROVIDER = {}));
var ReeRateTier;
(function (ReeRateTier) {
    ReeRateTier[ReeRateTier["fastestFee"] = 0] = "fastestFee";
    ReeRateTier[ReeRateTier["halfHourFee"] = 1] = "halfHourFee";
    ReeRateTier[ReeRateTier["hourFee"] = 2] = "hourFee";
    ReeRateTier[ReeRateTier["minimumFee"] = 3] = "minimumFee";
})(ReeRateTier = exports.ReeRateTier || (exports.ReeRateTier = {}));
//# sourceMappingURL=marketplace_types.js.map